import * as React from "react";

function TelescopeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M638.8 216.8 553.1 10.7c-3.502-8.125-12.69-12.02-20.94-8.647l-117.3 48.61c-8.252 3.375-12.06 12.64-8.68 20.89l3.228 7.802L74.25 241.7c-8.252 4.002-12.29 13.27-9.04 21.02l8.753 21.13L9.878 310.4C4.44 312.7 0 319.3 0 325.2c0 1.75.563 4.499 1.219 6.124l20.06 48.42c2.25 5.453 8.876 9.876 14.78 9.876 1.75 0 4.497-.547 6.122-1.219L106.2 361.9l8.737 21.09c3.252 7.625 12.52 11.48 21.27 8.479l127-43.69c.201.262.321.437.526.697L217.4 479.1c-4.406 12.5 2.124 26.22 14.63 30.63 2.57 1.87 5.27 2.27 7.07 2.27 9.877 0 19.16-6.155 22.63-16l42.9-121.6c4.676.973 9.501 1.551 14.48 1.551 4.971 0 9.822-.504 14.51-1.463l42.87 121.5C380.8 505.8 390.1 512 399.1 512a23.94 23.94 0 0 0 8.001-1.375c12.5-4.406 19.03-18.13 14.63-30.63l-46.42-131.5c9.738-12.28 15.79-27.6 15.79-44.49 0-.26-.08-.507-.083-.767l96.73-33.34 3.24 7.761c3.375 8.25 12.77 12.06 20.9 8.69l117.3-48.61C638.3 234.4 642.1 224.1 638.8 216.8zM319.1 327.1c-13.23 0-24-10.77-24-24s10.77-24 24-24c13.24 0 24 10.77 24 24s-9.9 24-24 24zm56-68.9c-13.21-15.89-32.86-26.2-55.14-26.2-39.11 0-70.78 31.2-71.83 70.05l-100.5 34.7L121 272.4l306.7-149.5 42.51 102.5-95.11 32.8zm148-28.5L461.83 81.8l58.27-24 61.26 147.8-58.26 24.1z"
  }));
}

const ForwardRef = React.forwardRef(TelescopeIcon);
export default ForwardRef;